module.exports = __webpack_public_path__ + "img/b_logo_1.491ecf21.png";